export const TARGET_WINDOW = 'Window';
export const TARGET_CONTENT_CANVAS = 'ContentCanvas';
export const THRESHOLD_MOUSE_LEAVE = 500;
